import axios from "axios";

const DOMAIN = process.env.REACT_APP_DOMAIN_NAME || "brandfinish.com";
const CANONICAL_HOSTS = new Set([DOMAIN, `www.${DOMAIN}`]);
const CANONICAL_BACKEND_URL = `https://api.${DOMAIN}`;

export function resolveBackendUrl(locationObj) {
  const configured = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
  if (configured) return configured;

  const activeLocation = locationObj ?? (typeof window !== "undefined" ? window.location : undefined);

  if (activeLocation) {
    const host = (activeLocation.hostname || "").toLowerCase();
    if (CANONICAL_HOSTS.has(host)) return CANONICAL_BACKEND_URL;
    if (activeLocation.origin) return activeLocation.origin;
  }

  return CANONICAL_BACKEND_URL;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem("bf_token", token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem("bf_token");
  }
}

export function getStoredToken() {
  return localStorage.getItem("bf_token");
}
